export const setNotifications = (state, notifications) => {
  state.notifications = notifications
}

export const setLoading = (state, value) => {
  state.loading = value;
}
